import { gql, useQuery } from "@apollo/client";
import { Paper, Stack, Typography } from "@mui/material";
import queryString from "query-string";
import React from "react";
import { useLocation } from "react-router-dom";
import { useBranchContext } from "../../../contexts/branchContext";
import useQueryString from "../../../hooks/useQueryString";
import AdminListContainer from "../../../styles/components/AdminListContainer";
import formatMoney from "../../../utils/formatMoney";
import DataTable from "../../common/DataTable";
import Loading from "../../common/Loading";
import Meta from "../../common/Meta";
import Pagination from "../../common/Pagination";
import Search from "../../common/Search";

export const PRODUCTS = gql`
  query Products($skip: Int, $take: Int, $where: ProductWhereInput) {
    products(skip: $skip, take: $take, where: $where) {
      id
      productCategory {
        id
        name
        productCategoryType
      }
      name
      price
      numberOfPax
      branch {
        id
        name
      }
    }
  }
`;

const PRODUCTS_COUNT = gql`
  query ProductsCount($where: ProductWhereInput) {
    productsCount(where: $where)
  }
`;

const ProductsPage = () => {
  const title = `Products`;
  const { branchFilterQueryString } = useBranchContext();
  const paramsObj = queryString.parse(useLocation().search);
  const page = parseInt(paramsObj.page) || 1;
  const perPage = 50;

  const {
    handleChangeQueryString: handleChangeSearch,
    handleSubmitQueryString: handleSubmitSearch,
    queryStringValue: searchTerm,
    initialQueryStringValue: searchQueryString,
  } = useQueryString("search");

  const where = {
    ...(branchFilterQueryString && {
      branch: {
        id: {
          equals: branchFilterQueryString,
        },
      },
    }),
    ...(searchQueryString && {
      OR: [
        {
          productCategory: {
            name: {
              contains: searchQueryString,
              mode: "insensitive",
            },
          },
        },
        {
          name: {
            contains: searchQueryString,
            mode: "insensitive",
          },
        },
      ],
    }),
  };
  const { data: { products } = {}, loading } = useQuery(PRODUCTS, {
    fetchPolicy: "network-only",
    variables: {
      skip: page * perPage - perPage,
      take: perPage,
      where,
    },
  });

  const columns = [
    {
      header: "Branch",
      accessor: "branch.name",
    },
    {
      header: "Product  Category",
      accessor: "productCategory.name",
    },
    {
      header: "Name",
      accessor: "name",
    },
    {
      header: "Price",
      accessor: "price",
      Cell: (children) => children && formatMoney(children),
    },
    {
      header: "No. of Pax",
      accessor: "numberOfPax",
      Cell: (children) => children && children.toLocaleString(),
    },
  ];
  if (loading) return <Loading />;
  return (
    <>
      <Meta title={`${title} | Meatsumo`} />
      <AdminListContainer>
        <Typography variant="h3" color="primary" gutterBottom>
          {title}
        </Typography>
        <Stack
          direction={{ xs: "column", md: "row" }}
          justifyContent="flex-end"
          alignItems={{ xs: null, md: "flex-end" }}
          spacing={1}
        >
          <Search
            handleChangeSearch={handleChangeSearch}
            handleSubmitSearch={handleSubmitSearch()}
            searchTerm={searchTerm}
          />
        </Stack>

        <Paper className="dataTableContainer">
          <DataTable data={products} columns={columns} />
        </Paper>
        <Pagination
          query={PRODUCTS_COUNT}
          variables={{
            where,
          }}
          perPage={perPage}
          page={Number(page)}
        />
      </AdminListContainer>
    </>
  );
};

export default ProductsPage;
